<!--
  a11y: when this slide-up acts as a modal dialog (roleDialog=true), we MUST
  prevent keyboard/SR Tab navigation from falling through to the underlying
  page (forms, map, etc.). aria-modal alone is honored by most modern screen
  readers in browse mode, but Tab order still escapes without an explicit
  focus trap. The slide-up-card component attaches a CDK FocusTrap
  programmatically (see the focusTrap / attachFocusTrap logic in
  slide-up-card.component.ts) on the false -> true transition of isCardOpen.
  We don't use the cdkTrapFocus directive here because some dialogs (e.g.
  the address-auto-complete inside source-destination-form) are kept in the
  DOM with isCardOpen=true even when they are slid out of view, and a
  directive would always attach the trap. Programmatic control lets us
  attach exactly once, when the dialog actually becomes visible.
-->
<div
  #cardElement
  [style.background-image]="
    !!showBackgroundImage
      ? 'url(/assets/images/route-planning/background.png)'
      : null
  "
  [style.background-size]="'cover'"
  [class]="class"
  [ngClass]="{
    'bg-no-repeat': !!showBackgroundImage,
    'slide-up': !!isCardOpen,
    'slide-down': !isCardOpen,
    'card bg-white h-full w-full flex flex-col': true
  }"
  [attr.role]="roleDialog ? 'dialog' : null"
  [attr.aria-modal]="roleDialog ? 'true' : null"
  [attr.aria-labelledby]="dialogAriaLabelledByAttr"
  [attr.aria-label]="dialogAriaLabelAttr"
>
  <app-route-planner-header [displayBackground]="!showBackgroundImage" [showLogo]="showLogoInHeader"
    [hideInDesktop]="hideHeaderInDesktop" [title]="title" [icon]="icon"
    [focusInitialOnBack]="focusInitialOnHeaderBack"
    [dialogTitleElementId]="headerDialogTitleElementId"
    (onHeaderButtonClick)="onHeaderButtonClick.emit($event)" style="flex: 0 0 auto">    <ng-content select="[headerItem]"></ng-content>
  </app-route-planner-header>

  <ng-content></ng-content>
</div>